
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EducationalQualificationDetailsModel, QualificationsClient, SeafarerApplicationLightViewModel } from "@/api-client";
import { QualificationDetailsContentBase } from "@/features/documents/qualifications/views/QualificationDetailsContentBase";

@Component({
    components: {},
})
export default class EducationalQualificationDetailsContent extends QualificationDetailsContentBase {
    @Prop()
    preloadedDetails?: EducationalQualificationDetailsModel;
    qualificationDetails!: EducationalQualificationDetailsModel;

    @Prop()
    isOfficial?: boolean;

    async created() {
        if (this.preloadedDetails) {
            this.qualificationDetails = this.preloadedDetails;
        } else {
            this.qualificationDetails = await new QualificationsClient().getEducationalQualification(this.id);
        }
        this.dataLoaded = true;
    }
}
